import { ResultContent, ResultHeaderImg, ResultPage } from './Quizzes.styles';
import CoinsChess from 'assets/icons/coins/CoinsChess.png';
import FinalResults from 'components/Quizzes/FinalResults';
import useMission from 'store/useMission';
import { useNavigate } from 'react-router-dom';
import { CelebrateLottie } from 'components/LottieFiles';
import useRewards from 'store/useRewards';
import useUser from 'store/useUser';
import { useEffect } from 'react';
import {
  finishQuest,
  handleNextMission,
  updateQuest,
} from 'helpers/QuestsHelpers';
import useSound from 'use-sound';
import collectCoins from 'assets/sounds/collectCoins.wav';
import { useMap } from 'react-map-gl';

const Result = () => {
  const { current: map } = useMap();
  // sounds
  const [playCollectCoins] = useSound(collectCoins);
  // states
  const { isLogged } = useUser();
  const {
    mission,
    setMission,
    selectedQuest,
    toggleMission,
    setRefresh,
    missionType,
    setMissionType,
  } = useMission();
  const { coins, setCoins, badges, setBadges } = useRewards();
  const navigate = useNavigate();

  // check if the user is logged or not
  useEffect(() => {
    if (!isLogged) {
      navigate('/start');
    }
    // eslint-disable-next-line
  }, []);

  // get total of correct number
  const getCorrectNumber = () => {
    return mission?.quizzes.filter((item: any) => item.isCorrect).length;
  };

  // get total of wrong number
  const getWrongNumber = () => {
    return mission?.quizzes.filter(
      (item: any) => item.completed && !item.isCorrect,
    ).length;
  };

  // get total coins
  const getTotalCoins = () => {
    const coins = mission?.quizzes
      .filter((item: any) => item.completed && item.isCorrect)
      .map((item: any) => (item.coins ? item.coins : 0));

    return coins?.reduce((a: any, b: any) => a + b, 0);
  };

  const collectResult = (e: any) => {
    map?.triggerRepaint();
    playCollectCoins();
    e.preventDefault();
    if (mission?.badges && mission?.badges[0]) {
      // check if badge exists
      const badgeExists = badges.find(
        (badge: any) => badge?._id === mission?.badges[0]?._id,
      );
      if (!badgeExists) {
        const newBadges: any = [...badges, mission?.badges[0]];
        setBadges(newBadges);
      }
    }
    const newMission = { ...mission };
    if (mission.endDialogue) {
      setCoins(coins + getTotalCoins());
      setRefresh(true);
      navigate('/map');
    } else {
      setMission(newMission);
      setCoins(coins + getTotalCoins());
      if (newMission.order.length > 0) {
        setRefresh(true);
        navigate('/map');
      } else {
        newMission.finished = true;

        setMission(newMission);
        const nextMission = handleNextMission(
          selectedQuest?.missions,
          mission?._id,
        );
        if (nextMission) {
          setMission(nextMission);
          selectedQuest?.missions.shift();
          // update quests
          updateQuest(selectedQuest);
        } else if (missionType === 'starter') {
          if (selectedQuest?.enigmas.length > 0) {
            navigate('/map/find-image');
            setMission(selectedQuest?.enigmas[0]);
            setMissionType('enigmas');
          }
        } else {
          finishQuest(selectedQuest?._id);
          updateQuest(selectedQuest);
          toggleMission(false);
        }
        navigate('/map');
      }
    }
  };

  return (
    <ResultPage>
      {mission && getCorrectNumber() > getWrongNumber() && (
        <CelebrateLottie className="absolute left-0 top-0 w-full" />
      )}
      <ResultHeaderImg src={CoinsChess} alt="chess" />
      <ResultContent>
        <FinalResults
          TotalCorrectAnswers={getCorrectNumber()}
          TotalWrongAnswers={getWrongNumber()}
          EarnedCoins={getTotalCoins()}
          EarnedObject={
            mission?.badges && mission?.badges[0]?.media[0]?.location
          }
          onClick={collectResult}
        />
      </ResultContent>
    </ResultPage>
  );
};

export default Result;
